import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import i18n from '@/i18n';

interface CriticalitySelectorProps {
  hideDetails?: boolean | string,
  required?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Criticality-Selector',
  props: {
  hideDetails: { type: [Boolean, String], default: false },
  required: { type: Boolean, default: true },
  value: null
},
  emits: ["input"],
  setup(__props) {



const { value: criticality } = __MACROS_useVModel(["value", undefined, "input"]);

const severityRules = _computed(() => [(value: number | undefined) => (value === undefined ? i18n.t('rules.severity_required') : true)]);
const items = _computed(() => [
  { value: 3, text: 'Low' },
  { value: 2, text: 'Moderate' },
  { value: 1, text: 'High' },
  { value: 0, text: 'Critical' },
]);

const picto = (item: { value: number, text: string }) => {
  switch (item.value) {
    case 0:
      return { icon: 'icon-chevron-triple-up', color: 'iconDanger' };
    case 1:
      return { icon: 'icon-chevron-double-up', color: 'iconAttention' };
    case 2:
      return { icon: 'icon-chevron-up', color: 'iconWarning' };
    case 3:
      return { icon: 'icon-subtract-middle', color: 'iconInfo' };
    default:
      return { icon: null, color: null };
  }
};

return { __sfc: true,criticality, severityRules, items, picto, _computed, __MACROS_useVModel, i18n }
}

})